module.exports = __webpack_public_path__ + "static/media/developer-wip.cfc469df.png";